module.exports = __webpack_public_path__ + "media/scripts/pages/csr/assets/media/logos/Enable Asia-5ab1e57d01996851b45e4dfc992a7705.png";